import React, { useState, useEffect } from 'react'
import { KTCard, KTCardBody } from '../../../../_metronic/helpers'
import DateRangePickers from '../../../sharedComponent/DateRangePickers/DateRangePickers'
import {
  GETCLIENTFEATUREFLAGS,
  GETPRODUCTSETUP,
  GET_CLIENT_ALLOWED_COMPONENTS,
  GET_SALES_CHANNEL_LIST,
  GET_SALES_CHANNEL_LIST_BY_USER,
  GET_TPV_RECORDING_LIST,
} from '../../../../utils/GraphQLAPI'
import { useLazyQuery } from '@apollo/client'
import moment from 'moment'
import { Spinner } from 'react-bootstrap'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { checkEmptyData, statusBadgeClassName } from '../../../../utils/helper'
import filterIcon from '../../../../_metronic/images/filter.svg'
import filterBlueIcon from '../../../../_metronic/images/filterBlueIcon.svg'
import filterFillIcon from '../../../../_metronic/images/filter-fill.svg'
import { UsersListPagination } from '../../../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import { GetReportModaal } from './GetReport/GetReportModal'
import searchicon from '../../../../_metronic/images/hd_search.svg'
import scheduleIcon from '../../../../_metronic/images/scheduledreportsicon.svg'
import { GLOBAL_CONSTANTS } from '../../../../utils/GlobalConstants'
import { AlertReportModaal } from './GetReport/AlertReportModal'
import { useLocalStorage } from '../../../../utils/useLocalStorage'
import { urlPath } from '../../../../utils/GlobalConstants'
import AlertSetup from './AlertSetup'
type LocationState = {
  filterOptions: any
}
const dateFormat = 'YYYY-MM-DD'
const initialFilter = {
  searchText: '',
  page: 1,
  perPage: 10,
  fromDate: new Date(
    moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
  ).toISOString(),
  toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
  utilityId: null,
  commodityId: null,
  contractTypeId: null,
  customerTypeId: null,
  tpvStatus: null,
  salesChannelIds: null,
  qcStatus: null,
  ediStatus: null,
}
const TPVRecordingList = ({ colors }: any) => {
  const [tpvRecordingData, setTpvRecordingData] = useState<any>()
  const { setItem, getItem } = useLocalStorage()
  const [sortConfig, setSortConfig] = useState<{
    by: string | null
    order: 'ASC' | 'DESC' | null
  }>({
    by: null,
    order: null,
  })


  const navigate = useNavigate()
  const location = useLocation()
  const [heading, setHeading] = useState('')
  const [urlRedirect, setUrlRedirect] = useState('')
  const [showReportModal, setShowReportModal] = useState<boolean>(false)
  const [showAlertReportModal, setShowAlertReportModal] = useState<boolean>(false)
  const [dateFilterType, setDateFilterType] = useState<any>('Last 30 Days')
  const [tpvType, setTpvType] = useState([{ text: 'IVR', value: 'IVR' }])
  const [ECIReport, setECIReport] = useState<any>(undefined)
  const [dynamicReportField, setDynamicReportField] = useState({
    isUtilityMeterNumberRequired: false,
    enableContractStartDate: false,
    enableLineTypeIntelligence: false,
  })
  const getUrlParams = useParams()

  useEffect(() => {
    if (getUrlParams.adminUser === 'systemadmin') {
      setHeading('TPV Reports')
      setUrlRedirect('tpv-report')
    } else if (getUrlParams.adminUser === 'qcuser') {
      setHeading('TPV Records List')
      setUrlRedirect('tpv-recording-list')
    }
  }, [getUrlParams])

  const handleSort = (by: string, order: 'ASC' | 'DESC') => {
    updatePage(0)
    setSortConfig({ by, order })

  }

  const SortableTH = ({
    title,
    columnKey,
  }: {
    title: string
    columnKey?: string
  }) => {
    const isAscActive =
      sortConfig.by === columnKey && sortConfig.order === 'ASC'

    const isDescActive =
      sortConfig.by === columnKey && sortConfig.order === 'DESC'

    return (
      <th className='min-w-200px ps-0 header_title'>
        <div className='d-flex align-items-center gap-2'>
          <span>{title}</span>

          {columnKey && tpvRecordingData?.getAllTpvs?.totalCount > 1 && (
            <div className='d-flex flex-column'>
              <span
                style={{
                  fontSize: '10px',
                  cursor: isAscActive ? 'not-allowed' : 'pointer',
                  color: isAscActive ? '#009ef7' : '#b5b5c3',
                  opacity: isAscActive ? 0.6 : 1,
                  pointerEvents: isAscActive ? 'none' : 'auto',
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!isAscActive) {
                    handleSort(columnKey, 'ASC')
                  }
                }}
              >
                ▲
              </span>
              <span
                style={{
                  fontSize: '10px',
                  cursor: isDescActive ? 'not-allowed' : 'pointer',
                  color: isDescActive ? '#009ef7' : '#b5b5c3',
                  opacity: isDescActive ? 0.6 : 1,
                  pointerEvents: isDescActive ? 'none' : 'auto',
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (!isDescActive) {
                    handleSort(columnKey, 'DESC')
                  }
                }}
              >
                ▼
              </span>
            </div>
          )}
        </div>
      </th>
    )
  }


  const [page, updatePage] = useState<any>(() => {
    if (location.pathname.includes(urlPath.tpvRecording)) {
      const savedPage = getItem(urlPath.tpvRecording)
      return savedPage ? parseInt(savedPage) - 1 : 0
    }
    return 0
  })
  const [filterOptions, setFilterOptions] = useState<any>({
    ...initialFilter,
    page: page + 1
  })
  const [localFilterOptions, setLocalFilterOptions] = useState({
    searchText: '',
    page: 1,
    perPage: 10,
    fromDate: new Date(
      moment(moment().subtract(29, 'days').toDate()).format(dateFormat) + 'T00:00:00'
    ).toISOString(),
    toDate: new Date(moment(moment().toDate()).format(dateFormat) + 'T23:59:00').toISOString(),
    utilityId: null,
    commodityId: null,
    contractTypeId: null,
    customerTypeId: null,
    tpvStatus: null,
    salesChannelIds: null,
    productIds: null,
    qcStatus: null,
    ediStatus: null,
    tpvType: null,
  })
  //to maintain state so that we can replace it in the location state when user navigate back detail page
  const [getProductSetup, { data: filterData }] = useLazyQuery(GETPRODUCTSETUP, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  useEffect(() => {
    if (location.pathname.includes(urlPath.tpvRecording)) {
      setItem(page + 1, urlPath.tpvRecording)
    }
  }, [page, location.pathname])


  const [getTPVrecordingList, { loading: tpvListLoading }] = useLazyQuery(GET_TPV_RECORDING_LIST, {
    variables: {
      getTpvsInput: filterOptions,
      orderBy: sortConfig.by ? {
        by: sortConfig.by,
        order: sortConfig.order
      } : null,
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data: any) => {
      setTpvRecordingData(data)
    },
  })

  const [getClientFeatureFlags] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    onCompleted: (data) => {
      const methods: { value: string; text: string }[] = []
      const {
        enableLiveAgent,
        enableTextTpv,
        enableOutBoundLiveAgent,
        isUtilityMeterNumberRequired,
        enableContractStartDate,
        enableLineTypeIntelligence,
        enableNoTPV,
      } = data.getClientFeatureFlags
      if (enableLiveAgent) {
        methods.push({ value: 'LIVE AGENT', text: 'Live Agent' })
      }
      if (enableTextTpv) {
        methods.push({ value: 'SMS TPV', text: 'Text TPV' })
      }

      if (enableOutBoundLiveAgent) {
        methods.push({ value: 'OUTBOUND LIVE AGENT', text: 'Outbound Live Agent' })
      }

      if (enableNoTPV) {
        methods.push({ value: 'NO TPV', text: 'No Tpv' })
      }

      setTpvType((prev) => [...prev, ...methods])
      setDynamicReportField((prevState) => ({
        ...prevState,
        isUtilityMeterNumberRequired,
        enableContractStartDate,
        enableLineTypeIntelligence,
      }))
    },
  })
  useEffect(() => {
    if ((location.state as LocationState)?.filterOptions) {
      setLocalFilterOptions((location.state as LocationState)?.filterOptions)
      setFilterOptions((location.state as LocationState)?.filterOptions)
    }
  }, [])

  const [getSparkComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setECIReport(data?.getClientAllowedComponents.includes('sparkCustomReport'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })

  useEffect(() => {
    getProductSetup()
    getClientFeatureFlags()
    getSparkComponents()
  }, [])
  useEffect(() => {
    getTPVrecordingList()
  }, [filterOptions, sortConfig])
  useEffect(() => {
    setFilterOptions((prevOptions: any) => ({
      ...prevOptions,
      page: page + 1
    }))

  }, [page])
  const updateRowsPerPage = (value: any) => {
    setFilterOptions((prevOptions: any) => {
      return { ...prevOptions, perPage: value, page: page + 1 }
    })
  }
  const handleSelectChange = (value: any, option: any) => {
    if (option === 'tpvstatus') {
      if (value === 'null') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, tpvStatus: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, tpvStatus: value }
        })
      }
    } else if (option === 'UTILITY') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, utilityId: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, utilityId: value }
        })
      }
    } else if (option === 'COMMODITY') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, commodityId: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, commodityId: value }
        })
      }
    } else if (option === 'CUSTOMER_TYPE') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, customerTypeId: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, customerTypeId: value }
        })
      }
    } else if (option === 'CONTRACT_TYPE') {
      if (value === '0') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, contractTypeId: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, contractTypeId: value }
        })
      }
    } else if (option === 'salesChannelIds') {
      if (value === 'null') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, salesChannelIds: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, salesChannelIds: value }
        })
      }
    } else if (option === 'qcStatus') {
      if (value === 'null') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, qcStatus: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, qcStatus: value }
        })
      }
    } else if (option === 'ediStatus') {
      if (value === 'null') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, ediStatus: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, ediStatus: value }
        })
      }
    } else if (option === 'tpvType') {
      if (value === 'null') {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, tpvType: null }
        })
      } else {
        setLocalFilterOptions((prevOptions: any) => {
          return { ...prevOptions, tpvType: value }
        })
      }
    }
  }

  const getdataFromDateFilter = (fromDate: any, toDate: any, objDays: any) => {
    updatePage(0)
    setDateFilterType(objDays)
    setFilterOptions((prevOptions: any) => {
      return {
        ...prevOptions,
        fromDate,
        toDate,
        page: page + 1,
      }
    })
  }
  // Manual
  const openReportModal = (e: any, editIdValue: any) => {
    setShowReportModal(true)
  }

  const handleCloseReportModal = () => {
    // refetch()
    setShowReportModal(false)
  }
  const openAlertReportModal = (e: any, editIdValue: any) => {
    setShowAlertReportModal(true)
  }

  const handleCloseAlertReportModal = () => {
    // refetch()
    setShowAlertReportModal(false)
  }
  const openQcEdit = (objItem: any) => {
    navigate(`/${getUrlParams.adminUser}/${urlRedirect}/customer-details`, {
      state: {
        tpvDetails: {
          tpvId: objItem.tpvId,
          tpvStatus: objItem.tpvStatus,
          qcStatus: objItem.qcStatus,
          disposition: objItem.disposition?.length > 0 ? objItem.disposition : '',
          ediStatus: objItem.ediStatus,
          enrollmentPosition: objItem.enrollmentPosition
        },
        filterOptions,
      },
    })
  }

  const [salesChannel, setSalesChannel] = useState<any>([])

  const [getQcListByTeamAdmin] = useLazyQuery(GET_SALES_CHANNEL_LIST, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    variables: {
      salesChannelListInput: {
        searchText: '',
        page: null,
        perPage: null,
      },
    },
    onCompleted: (data) => {
      setSalesChannel(data.getSalesChannelList.salesChannels)
    },
    onError: (err) => console.log('error', err),
  })

  const [getSalesChannelListByUser] = useLazyQuery(GET_SALES_CHANNEL_LIST_BY_USER, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (data) => {
      setSalesChannel(data.getSalesChannelListByUser.salesChannels)
    },
    onError: (err) => console.log('error', err),
  })

  useEffect(() => {
    if (getUrlParams.adminUser === 'qcuser') {
      getSalesChannelListByUser()
    }
    if (getUrlParams.adminUser === 'systemadmin') {
      getQcListByTeamAdmin()
    }
  }, [])

  const hasData = tpvRecordingData?.getAllTpvs?.totalCount !== 0;
  return (
    <>
      <div
        className='d-flex flex-row justify-content-between'
        style={{ height: '48px', marginBottom: '20px' }}
      >
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>{heading}</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - {heading}</span>
        </div>
        <div className='d-flex gap-5'>
          <div className='m-0 '>
            <button
              className='btn text-gray-600 bg-white fw-bold fs-base ms-5'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              onClick={() => getProductSetup()}
            >
              {colors === 'white' ? (
                <img
                  src={
                    JSON.stringify({ ...initialFilter, fromDate: '', toDate: '' }) ===
                      JSON.stringify({
                        ...filterOptions,
                        fromDate: '',
                        toDate: '',
                        searchText: '',
                        page: 1,
                        perPage: 10,
                        salesChannelIds: null,
                      })
                      ? filterIcon
                      : filterFillIcon
                  }
                  alt=''
                  className='svg-icon svg-icon-1 text-gray-600'
                />
              ) : (
                <img
                  src={
                    JSON.stringify({ ...initialFilter, fromDate: '', toDate: '' }) ===
                      JSON.stringify({
                        ...filterOptions,
                        fromDate: '',
                        toDate: '',
                        searchText: '',
                        page: 1,
                        perPage: 10,
                        salesChannelIds: null,
                      })
                      ? filterBlueIcon
                      : filterFillIcon
                  }
                  alt=''
                  className='svg-icon svg-icon-1 text-gray-600'
                />
              )}
              Filter
            </button>

            <div
              className='menu menu-sub menu-sub-dropdown w-350px w-md-550px'
              data-kt-menu='true'
              id='kt_menu_63b3cb4f9c10f'
            >
              <div className='px-7 py-5'>
                <div className='fs-4 fw-bold text-gray-900'>Filter Options</div>
              </div>
              <div className='separator border-gray-200'></div>
              <div className='px-7 py-5'>
                <div className='row row-cols-1 row-cols-lg-2'>
                  {filterData &&
                    filterData?.getProductDetail.map((item: any) => {
                      if (item.enum === 'UTILITY') {
                        return (
                          <div className='col mb-3'>
                            <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                              <span>{item.type}</span>
                            </label>
                            <select
                              className='form-select form-select-solid'
                              value={
                                localFilterOptions.utilityId === null
                                  ? '0'
                                  : localFilterOptions.utilityId
                              }
                              onChange={(e) => handleSelectChange(e.target.value, item.enum)}
                              aria-label='Select example'
                            >
                              <option value='0'>Select an option</option>
                              {item.names.map((options: any) => {
                                return <option value={options.id}>{options.value}</option>
                              })}
                            </select>
                          </div>
                        )
                      } else if (item.enum === 'COMMODITY') {
                        return (
                          <div className='col mb-3'>
                            <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                              <span>{item.type}</span>
                            </label>
                            <select
                              className='form-select form-select-solid'
                              value={
                                localFilterOptions.commodityId === null
                                  ? '0'
                                  : localFilterOptions.commodityId
                              }
                              onChange={(e) => handleSelectChange(e.target.value, item.enum)}
                              aria-label='Select example'
                            >
                              <option value='0'>Select an option</option>
                              {item.names.map((options: any) => {
                                return <option value={options.id}>{options.value}</option>
                              })}
                            </select>
                          </div>
                        )
                      } else if (item.enum === 'CONTRACT_TYPE') {
                        return (
                          <div className='col mb-3'>
                            <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                              <span>{item.type}</span>
                            </label>
                            <select
                              className='form-select form-select-solid'
                              value={
                                localFilterOptions.contractTypeId === null
                                  ? '0'
                                  : localFilterOptions.contractTypeId
                              }
                              onChange={(e) => handleSelectChange(e.target.value, item.enum)}
                              aria-label='Select example'
                            >
                              <option value='0'>Select an option</option>
                              {item.names.map((options: any) => {
                                return <option value={options.id}>{options.value}</option>
                              })}
                            </select>
                          </div>
                        )
                      } else if (item.enum === 'CUSTOMER_TYPE') {
                        return (
                          <div className='col mb-3'>
                            <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                              <span>{item.type}</span>
                            </label>
                            <select
                              className='form-select form-select-solid'
                              value={
                                localFilterOptions.customerTypeId === null
                                  ? '0'
                                  : localFilterOptions.customerTypeId
                              }
                              onChange={(e) => handleSelectChange(e.target.value, item.enum)}
                              aria-label='Select example'
                            >
                              <option value='0'>Select an option</option>
                              {item.names.map((options: any) => {
                                return <option value={options.id}>{options.value}</option>
                              })}
                            </select>
                          </div>
                        )
                      }
                      return null;
                    })}
                  {getUrlParams.adminUser === 'systemadmin' && (
                    <div className='col mb-3'>
                      <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                        <span>Sales Channel</span>
                      </label>
                      <select
                        className='form-select form-select-solid'
                        value={
                          localFilterOptions.salesChannelIds === null
                            ? '0'
                            : localFilterOptions.salesChannelIds
                        }
                        onChange={(e) => handleSelectChange(e.target.value, 'salesChannelIds')}
                        aria-label='Select example'
                      >
                        <option value='null'>Select an option</option>
                        {salesChannel?.map((options: any) => {
                          return (
                            <option value={options.salesChannelId}>
                              {options.salesChannelName}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  )}

                  {getUrlParams.adminUser === 'qcuser' && (
                    <div className='col mb-3'>
                      <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                        <span>Sales Channel</span>
                      </label>
                      <select
                        className='form-select form-select-solid'
                        value={
                          localFilterOptions.salesChannelIds === null
                            ? '0'
                            : localFilterOptions.salesChannelIds
                        }
                        onChange={(e) => handleSelectChange(e.target.value, 'salesChannelIds')}
                        aria-label='Select example'
                      >
                        <option value='null'>Select an option</option>
                        {salesChannel?.map((options: any) => {
                          return <option value={options.id}>{options.name}</option>
                        })}
                      </select>
                    </div>
                  )}
                  <div className='col mb-3'>
                    <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                      <span>TPV Status</span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      value={
                        localFilterOptions.tpvStatus === null
                          ? 'null'
                          : localFilterOptions.tpvStatus
                      }
                      onChange={(e) => handleSelectChange(e.target.value, 'tpvstatus')}
                      aria-label='Select example'
                    >
                      <option value='null'>Select an option</option>
                      <option value='FAILED'>Failed</option>
                      <option value='INCOMPLETE'>Incomplete</option>
                      <option value='PASSED'>Passed</option>
                      <option value='PENDING'>Pending</option>
                      <option value='UNVERIFIED'>Unverified</option>
                    </select>
                  </div>
                  <div className='col mb-3'>
                    <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                      <span>QC Status</span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      value={
                        localFilterOptions.qcStatus === null ? 'null' : localFilterOptions.qcStatus
                      }
                      onChange={(e) => handleSelectChange(e.target.value, 'qcStatus')}
                      aria-label='Select example'
                    >
                      <option value='null'>Select an option</option>
                      <option value='ACCEPTED'>Accepted</option>
                      <option value='PENDING'>Pending</option>
                      <option value='REJECTED'>Rejected</option>
                      <option value='AUTO_APPROVED'>Auto Approved</option>
                    </select>
                  </div>
                  <div className='col mb-3'>
                    <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                      <span>TPV Type</span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      value={
                        localFilterOptions.tpvType === null ? 'null' : localFilterOptions.tpvType
                      }
                      onChange={(e) => handleSelectChange(e.target.value, 'tpvType')}
                      aria-label='Select example'
                    >
                      <option value='null'>Select an option</option>
                      {tpvType.map((type, i) => (
                        <option value={type.value} key={i}>{type.text}</option>
                      ))}
                    </select>
                  </div>
                  <div className='col mb-3'>
                    <label className='fs-base text-fray-700 fw-semibold form-label mt-3'>
                      <span>EDI Status</span>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      value={
                        localFilterOptions.ediStatus === null
                          ? 'null'
                          : localFilterOptions.ediStatus
                      }
                      onChange={(e) => handleSelectChange(e.target.value, 'ediStatus')}
                      aria-label='Select example'
                    >
                      <option value='null'>Select an option</option>
                      <option value='PENDING'>Not Assigned</option>
                      <option value='COMPLETED'>Completed</option>
                      <option value='REJECTED'>Rejected</option>
                    </select>
                  </div>
                </div>
                <div className='d-flex flex-row justify-content-end mt-4'>
                  <button
                    type='button'
                    className='btn btn-light me-3 fs-7 fw-semibold text-gray-600'
                    onClick={() => {
                      setLocalFilterOptions({
                        searchText: '',
                        page: 1,
                        perPage: 10,
                        fromDate: new Date(
                          moment(moment().subtract(29, 'days').toDate()).format(dateFormat) +
                          'T00:00:00'
                        ).toISOString(),
                        toDate: new Date(
                          moment(moment().toDate()).format(dateFormat) + 'T23:59:00'
                        ).toISOString(),
                        utilityId: null,
                        commodityId: null,
                        contractTypeId: null,
                        customerTypeId: null,
                        tpvStatus: null,
                        salesChannelIds: null,
                        productIds: null,
                        qcStatus: null,
                        tpvType: null,
                        ediStatus: null,
                      })
                    }}
                  >
                    Reset
                  </button>
                  <button
                    type='button'
                    data-kt-menu-dismiss='true'
                    onClick={() => {
                      setFilterOptions((prev: any) => {
                        return {
                          ...localFilterOptions,
                          searchText: prev.searchText,
                          perPage: prev.perPage,
                          fromDate: prev.fromDate,
                          toDate: prev.toDate,
                          page: 1,
                        }
                      })
                    }}
                    className='btn btn-primary fs-7 fw-semibold text-gray-100'
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
          <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} colors={'white'} />

          <div >
            <AlertSetup />
          </div>
        </div>
      </div>
      <KTCard>
        <div className='card card-custom'>
          <div className='card-header card-body pb-0 border-0'>
            <div className='card-title'>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-ecommerce-order-filter='search'
                  className='form-control form-control-solid w-250px pe-14'
                  placeholder='Search'
                  onChange={(e) =>
                    setFilterOptions((prev: any) => {
                      updatePage(0)
                      return { ...prev, searchText: e.target.value, page: page + 1 }
                    })
                  }
                />
                <span className='svg-icon svg-icon-1 position-absolute me-4' style={{ right: 0 }}>
                  <img src={searchicon} alt='search' />
                </span>
              </div>
            </div>
            <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>
              <button
                className='btn btn-light-primary btn-active-light-primary fs-6 p-3 w-142px h-43px ms-4'
                type='button'
                onClick={() =>
                  navigate(`/${getUrlParams.adminUser}/${urlRedirect}/scheduled-reports`)
                }
              >
                <span className='svg-icon svg-icon-6 svg-icon-muted me-1'>
                  <img src={scheduleIcon} alt='scheduleIcon' />
                </span>
                <span>Scheduled Reports</span>
              </button>
              <div className={`m-0`}>
                <button
                  className='btn btn-light-primary btn-active-light-primary fs-6 p-3 w-142px h-43px ms-4'
                  onClick={(e) => openReportModal(e, '')}
                  type='button'
                >
                  <span className='svg-icon svg-icon-6 svg-icon-muted me-1'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='16'
                      height='16'
                      fill='none'
                      className='bi bi-download'
                      viewBox='0 0 16 16'
                    >
                      <path
                        d='M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z'
                        fill='currentColor'
                      />
                      <path
                        d='M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z'
                        fill='currentColor'
                      />
                    </svg>
                  </span>
                  <span>Get Report</span>
                </button>
                {
                  <GetReportModaal
                    show={showReportModal}
                    handleClose={handleCloseReportModal}
                    filterOptions={filterOptions}
                    dateFilterType={dateFilterType}
                    dynamicReportField={dynamicReportField}
                    ECIReport={ECIReport}
                  />
                }
              </div>
              <div className={`m-0`}>
                <button
                  className='btn btn-light-primary btn-active-light-primary fs-6 p-3 w-142px h-43px ms-4'
                  onClick={(e) => openAlertReportModal(e, '')}
                  type='button'
                >
                  <span>Alerts Report</span>
                </button>
                {
                  <AlertReportModaal
                    show={showAlertReportModal}
                    handleClose={handleCloseAlertReportModal}
                    filterOptions={filterOptions}
                    dateFilterType={dateFilterType}
                  />
                }
              </div>
            </div>
          </div>
          <KTCardBody className='pe-0 py-0 min-h-400px' scroll>
            <div className='table-responsive-xxl'>
              <table className='table table-row-dashed gy-7 gs-7'>
                <thead>
                  <tr className='fw-bold fs-6 text-gray-700 border-bottom-2 border-gray-200'>
                    <SortableTH title='Customer First Name' columnKey='cusFirstName' />
                    <SortableTH title='Customer Last Name' columnKey='cusLastName' />
                    <SortableTH title='Business Name' columnKey='businessName' />
                    <SortableTH title='Sales Channel' columnKey='salesChannelName' />
                    <SortableTH title='Agent Name' columnKey='agentFirstName' />
                    <SortableTH title='Agent Email' />
                    <SortableTH title='Type' columnKey='tpvType' />
                    <SortableTH title='QC User Name' columnKey='qcUserName' />
                    <SortableTH title='Service Address 1' />
                    <SortableTH title='Service Address 2' />
                    <SortableTH title='Service City' />
                    <SortableTH title='Service State' columnKey='state' />
                    <SortableTH title='Service Zip' />
                    <SortableTH title='Primary Phone' columnKey='primaryPhone' />
                    <SortableTH title='Account Number' />
                    <SortableTH title='Product Name' columnKey='productName' />
                    <SortableTH title='Customer Type' columnKey='customerType' />
                    <SortableTH title='Contract Type' columnKey='contractType' />
                    <SortableTH title='Commodity' columnKey='productType' />
                    <SortableTH title='Utility' columnKey='utility' />
                    <SortableTH title='TPV Date' columnKey='tpvDate' />
                    <SortableTH title='TPV Duration' columnKey='roundedDuration' />
                    <SortableTH title='TPV Status' columnKey='tpvStatus' />
                    <SortableTH title='QC Status' columnKey='qcStatus' />
                    <SortableTH title='EDI Status' columnKey='ediStatus' />
                    <SortableTH title='Confirmation Number' />
                    <SortableTH title='Disposition' />
                    <SortableTH title='Document Delivery' columnKey='documentDelivery' />
                  </tr>
                </thead>
                <tbody>
                  {tpvListLoading ? (
                    <tr>
                      <td colSpan={29} style={{ paddingLeft: '10%' }} >
                        <div className="pl-[10%]">
                          <Spinner
                            animation="border"
                            role="status"
                            className="text-gray-600"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </div>
                      </td>
                    </tr>
                  ) : hasData ? (
                    tpvRecordingData?.getAllTpvs?.tpvs?.map((item: any) => {
                      let displayTpvType = '';
                      if (item?.tpvType === 'SMS TPV') {
                        displayTpvType = 'TEXT TPV';
                      } else if (item?.tpvType === GLOBAL_CONSTANTS.tpvType.outboundLiveAgent) {
                        displayTpvType = 'OUTBOUND LIVE AGENT';
                      } else {
                        displayTpvType = item?.tpvType;
                      }

                      let displayQcStatus = '';
                      if (item?.qcStatus === 'AUTO_APPROVED') {
                        displayQcStatus = 'AUTO APPROVED';
                      } else if (item?.qcStatus === 'NEED_MORE_INFORMATION') {
                        displayQcStatus = 'NEED MORE INFORMATION';
                      } else {
                        displayQcStatus = item?.qcStatus;
                      }
                      return (
                        <tr
                          key={item.id}
                          className="border-bottom-2 cursor-pointer"
                          onClick={() => openQcEdit(item)}
                        >
                          <td className='text-gray-500 ps-0  fs-6 fw-semibold'>
                            {checkEmptyData(item?.cusFirstName)}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {checkEmptyData(item?.cusLastName)}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {checkEmptyData(item?.businessName)}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.salesChannelName}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>{`${item?.agentFirstName} ${item?.agentLastName}`}</td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {`${item?.agentEmailId}`}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {checkEmptyData(displayTpvType)}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {checkEmptyData(item?.qcUserName)}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.serviceAddress1}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.serviceAddress2}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>{item?.city}</td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>{item?.state}</td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>{item?.zipCode}</td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.primaryPhone}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>{item?.uan}</td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.productName}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.customerType}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.contractType}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.productType}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>{item?.utility}</td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.tpvDate &&
                              `${moment
                                .utc(item?.tpvDate)
                                .local()
                                .format('DD MMM YYYY,hh:mm A')}`}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.roundedDuration &&
                              (() => {
                                return moment
                                  .utc(
                                    moment
                                      .duration(item?.roundedDuration, 'seconds')
                                      .asMilliseconds()
                                  )
                                  .format(item?.roundedDuration > 60 ? 'm [mins]' : 'm [min]')
                              })()}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            <span className={`${statusBadgeClassName(item?.tpvStatus)}`}>
                              {item?.tpvStatus === 'NO_TPV' ? 'NO TPV' : item?.tpvStatus}
                            </span>
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            <span className={`${statusBadgeClassName(item?.qcStatus)}`}>
                              {displayQcStatus}
                            </span>
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            <span className={`${statusBadgeClassName(item?.ediStatus)}`}>
                              {item?.ediStatus}
                            </span>
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item.tpvStatus === 'PASSED' ? item.confirmationNumber : '-'}
                          </td>
                          <td
                            className={`text-gray-500 ps-0 fs-6 w-150px fw-semibold  ${item?.disposition ? 'dispositionEllipsis' : ''
                              } `}
                            data-toggle='tooltip'
                            data-placement='bottom'
                            title={item?.disposition}
                            style={{ textOverflow: 'ellipsis' }}
                          >
                            {item?.disposition}
                          </td>
                          <td className='text-gray-500 ps-0 fs-6 fw-semibold'>
                            {item?.documentDelivery === 'EMAILTEXT' ? 'EMAIL&TEXT' : item?.documentDelivery}
                          </td>

                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={29} className="text-muted fs-4 fw-semibold" style={{ paddingLeft: '10%' }} >
                        No Results Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </KTCardBody>
          {tpvRecordingData?.getAllTpvs?.totalCount > 0 && (
            <div className='card-footer border-0'>
              <UsersListPagination
                page={page}
                total={tpvRecordingData?.getAllTpvs.totalCount}
                updatePage={updatePage}
                recordsPerPage={(e: any) => {
                  updateRowsPerPage(parseInt(e))
                }}
                rowsPerPage={filterOptions.perPage}
              />
            </div>
          )}        </div>
      </KTCard>
    </>
  )
}

export default TPVRecordingList
